import React, { useState, useEffect } from "react";
import { Form, Button } from "antd";
import "../AddCategory/AddCategory.scss";
import "../../../styles/main.scss";
import FormInput from "../../FormInputs/FormInput";
import FormSelect from "../../FormInputs/FormSelect";
import FormEditor from "../../FormInputs/FormEditor";
import DateTimeInput from "../../FormInputs/FormDateTimeInput";
import UploadWithCrop from "../../FormInputs/UploadInput";
import FormTextarea from "../../FormInputs/FormTextarea";
import { IMAGE_BASE_PATH } from "../../../utils/constant";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  ADD_CATEGORY,
  GET_CATEGORY_DROPDOWN,
  UPDATE_CATEGORY,
} from "../../../utils/apiPath";
import { getApi, postApi } from "../../../utils/apiServices";
import ToastHelper from "../../../services/ToastHelper";

const schemaTypes = [
  { label: "Product Schema", value: "1" },
  { label: "BreedCrumb Schema", value: "2" },
  { label: "Review Schema", value: "3" },
  { label: "FAQ Schema", value: "4" },
];

const publishingTypes = [
  { label: "Active", value: true },
  { label: "InActive", value: false },
];

const AddSubCategory = () => {
  const { id, subId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [formItems, setFormItems] = useState([
    { index: 0, schemaType: "", schemaContent: "" },
  ]);
  const [categoryData, setCategoryData] = useState(null);
  const [base64, setBase64] = useState(null);
  const [image, setImage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (subId) {
      getCategoryData();
    }
  }, [subId]);

  useEffect(() => {
    if (categoryData) {
      const editData = categoryData;
      setImage(`${IMAGE_BASE_PATH}${editData?.media?.url}`);
      form.setFieldsValue({
        title: editData?.title,
        description: editData?.description,
        metaTitle: editData?.metaTitle,
        metaDescription: editData?.metaDescription,
        pageUrl: editData?.urlName,
        publishStatus: editData?.publishStatus,
        publishDate: editData?.publishDate,
        altText: editData?.media?.altText,
        image: editData?.media?.url,
      });

      const schemaItems = editData?.schema?.map((item, index) => ({
        index: index,
        [`schemaType${index}`]: item?.type,
        [`schemaContent${index}`]: item?.content,
      }));
      setFormItems(schemaItems);
      form.setFieldsValue(
        schemaItems?.reduce((acc, item) => {
          acc[`schemaType${item.index}`] = item[`schemaType${item.index}`];
          acc[`schemaContent${item.index}`] =
            item[`schemaContent${item.index}`];
          return acc;
        }, {})
      );
    }
  }, [categoryData]);

  const getCategoryData = async () => {
    try {
      const res = await getApi(`${GET_CATEGORY_DROPDOWN}?categoryId=${subId}`);

      if (res?.statusCode === 200) {
        setCategoryData(res?.data);
        // ToastHelper.success("success");
        return res?.data;
      } else {
        ToastHelper.error("Something went wrong. Please try again.");
      }
    } catch (err) {
      // ToastHelper.error(
      //   "Failed to connect to the server. Please try again later."
      // );
    } finally {
      // setIsLoading(false);
    }
    return null;
  };

  const onFinish = (values) => {
    const schemas = [];
    Object.entries(values).forEach(([key, value]) => {
      const match = key.match(/(schemaType|schemaContent)(\d+)/);
      if (match) {
        const [_, type, index] = match;
        const idx = Number(index);

        if (!schemas[idx]) schemas[idx] = {};

        schemas[idx][type === "schemaType" ? "type" : "content"] = value;
      }
    });

    handleAddCategory(values, base64, schemas);
  };

  const handleUpload = (croppedBlob) => {
    setBase64(croppedBlob);
  };

  const addFormItem = () => {
    setFormItems((prevItems) => [
      ...prevItems,
      { index: prevItems.length, schemaType: "", schemaContent: "" },
    ]);
  };

  const removeFormItem = (index) => {
    setFormItems((prevItems) =>
      prevItems.filter((item) => item.index !== index)
    );
  };

  const handleAddCategory = async (data, file, schemas) => {
    const payload = {
      title: data?.title,
      description: data?.description,
      metaTitle: data?.metaTitle,
      metaDescription: data?.metaDescription,
      urlName: data?.pageUrl,
      schema: schemas,
      media: {
        altText: data?.altText,
        media: file?.split(",")[1],
      },
      parentCategoryId: id,
      id: Number(subId) || undefined,
    };
    const apiUrl = subId ? UPDATE_CATEGORY : ADD_CATEGORY;

    try {
      const { statusCode, data, message, error } = await postApi(
        apiUrl,
        payload
      );

      if (statusCode === 200) {
        ToastHelper.success("success");
        navigate(-1);
      } else if (statusCode === 400) {
        ToastHelper.error(
          error || message || "An error occurred. Please try again."
        );
      } else {
        ToastHelper.error("Something went wrong. Please try again.");
      }
    } catch (err) {
      ToastHelper.error(
        "Failed to connect to the server. Please try again later."
      );
    } finally {
      setIsLoading(false);
    }
  };

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <div className="add-category">
      <div className="add-category_heading">
        <h1>
          {location?.state?.category?.title} - {subId ? "Edit" : "Add"}{" "}
          collection
        </h1>
      </div>
      <div className="add-category_container">
        <Form
          className="add-category-form"
          form={form}
          layout="vertical"
          onFinish={onFinish}
        >
          <div className="add-category_form">
            <div className="add-category_form_left">
              <div className="add-category_form_card">
                <FormInput
                  label="Title"
                  name="title"
                  rules={[{ required: true, message: "Please enter title" }]}
                  placeholder="Enter category title"
                />
                <FormEditor
                  label="Description"
                  name="description"
                  rules={[
                    { required: true, message: "Please enter description" },
                  ]}
                  placeholder="Enter category description..."
                />
              </div>
              <div className="add-category_form_card">
                <FormInput
                  label="Meta Title"
                  name="metaTitle"
                  rules={[
                    { required: true, message: "Please enter meta title" },
                  ]}
                  placeholder="Enter meta title"
                  minLength={10}
                  maxLength={70}
                  showCount={true}
                />

                <FormTextarea
                  label="Meta Description"
                  name="metaDescription"
                  rules={[
                    {
                      required: true,
                      message: "Please enter meta description",
                    },
                  ]}
                  placeholder="Enter meta description"
                  minLength={30}
                  maxLength={200}
                  showCount={true}
                />

                <FormInput
                  label="Page Url"
                  name="pageUrl"
                  rules={[{ required: true, message: "Please enter page url" }]}
                  placeholder="Enter Page Url"
                />
              </div>
              {/* <div className="add-category_form_card">
                {formItems?.map((item, index) => (
                  <div key={index}>
                    <div className="add-category_form_card_remove">
                      <h3>Schema {index + 1}</h3>
                      {index !== 0 && (
                        <Button
                          danger
                          type="primary"
                          onClick={() => removeFormItem(item?.index)}
                        >
                          Remove
                        </Button>
                      )}
                    </div>
                    <FormSelect
                      label={`Schema Type `}
                      name={`schemaType${item?.index}`}
                      // rules={[
                      //   {
                      //     required: true,
                      //     message: "Please select a schema type",
                      //   },
                      // ]}
                      options={schemaTypes}
                      placeholder="Select a schema type"
                    />
                    <Form.Item shouldUpdate>
                      {({ getFieldValue }) => {
                        const schemaType = getFieldValue(
                          `schemaType${item?.index}`
                        );
                        return (
                          <FormTextarea
                            label={`Schema Content `}
                            name={`schemaContent${item?.index}`}
                            rules={[
                              {
                                required: !!schemaType,
                                message: "Please enter schema content",
                              },
                            ]}
                            placeholder="Enter schema content"
                          />
                        );
                      }}
                    </Form.Item>
                  </div>
                ))}
                <Button onClick={addFormItem}>Add New Schema</Button>
              </div> */}
            </div>
            <div className="add-category_form_right">
              {/* <div className="add-category_form_card">
                <FormSelect
                  label="Publishing Status"
                  name="publishStatus"
                  rules={[
                    {
                      required: true,
                      message: "Please enter publishing status",
                    },
                  ]}
                  placeholder="Enter publishing status"
                  options={publishingTypes}
                />

                <DateTimeInput
                  label="Publishing Date"
                  name="publishDate"
                  rules={[
                    {
                      required: true,
                      message: "Please select publishing date",
                    },
                  ]}
                  format="YYYY-MM-DD HH:mm:ss"
                  type="datetime"
                  showTime={true}
                  form={form}
                />
              </div> */}
              <div className="add-category_form_card">
                <UploadWithCrop onUpload={handleUpload} image={image} required={true} form={form} />
              </div>
            </div>
          </div>
          <div className="form-submit">
            <Button onClick={handleBack} variant="outlined">
              back
            </Button>
            <Button type="primary" htmlType="submit" loading={isLoading}>
              {subId ? "Update" : "Add"} collection
            </Button>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default AddSubCategory;
